import { BackendReminder } from './reminder-fields.type';

export class Reminder {
    /**
     * Promise that resolves in the reminder's set time.
     * Rejects if the alarm gets cancelled.
     */
    private alarmTriggers: Promise<Reminder>;
    /**
     * Promise's rejection function is stored as member so it can be called outside it.
     */
    private alarmTriggersPromiseRejection: (reason?: any) => void;
    /**
     * Timeout's reference for the possibility to cancel it
     */
    private timeoutId: number;
    /**
     * Notifies with a promise in the set time
     * @param backendReminder Fields returned from the backend
     * @param onCancelledCallback Optional callback for reacting possible cancellation of the reminder
     */
    constructor(
        public backendReminder: BackendReminder,
        public onCancelledCallback?: (reminder: Reminder) => void
    ) {
        const currentTimeMs = new Date().getTime();
        const millisecondsUntilTriggering = backendReminder.alarmingTime.getTime() - currentTimeMs;
        this.alarmTriggers = new Promise((resolve, reject) => {
            this.alarmTriggersPromiseRejection = reject;
            this.timeoutId = window.setTimeout(() => {
                resolve(this);
            }, millisecondsUntilTriggering);
        });
        this.alarmTriggers.catch(msg => {
            // Default rejection handling
            console.warn(msg);
        });
    }
    public cancelAlarm(): void {
        this.alarmTriggersPromiseRejection(`The reminder ${this.backendReminder.id} was cancelled`);
        window.clearTimeout(this.timeoutId);
        if (this.onCancelledCallback !== undefined) {
            this.onCancelledCallback(this);
        }
    }
    public getAlarmTriggeringPromise = (): Promise<Reminder> => this.alarmTriggers;
}
